const networks = {
  online: "https://coapp.tosoptech.com/",
  offline: "http://0.0.0.0:8000/api/",
  system_ip: "http://192.168.1.11:8000/api/"
};
const server = networks.system_ip;
export default server;
